import { Skeleton } from '@chakra-ui/react';
import { createColumnHelper } from '@tanstack/react-table';

export type TListOfCardsByBrokenRuleDataTableData = {
  primaryKey: string | number,
  cardNumber: string,
  holderName: string,
  expirationDate: string,
  counter: string,
  sumRiskLevel: string,
};

type Props = {
  isLoading: boolean | undefined,
};

const columnHelper = createColumnHelper<TListOfCardsByBrokenRuleDataTableData>();

export function getListOfCardsByBrokenRuleDataTableColumns({ isLoading }: Props) {
  return [
    columnHelper.accessor('cardNumber', {
      id: 'cardNumber',
      header: 'Num. Carte',
      cell: (props) => {
        return (
          <Skeleton isLoaded={!isLoading}>
            {props.getValue()}
          </Skeleton>
        );
      },
    }),

    columnHelper.accessor('holderName', {
      id: 'holderName',
      header: 'Nom Porteur',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),

    columnHelper.accessor('expirationDate', {
      id: 'expirationDate',
      header: 'Date Exp.',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),
    
    columnHelper.accessor('counter', {
      id: 'counter',
      header: 'Compteur',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),
    
    columnHelper.accessor('sumRiskLevel', {
      id: 'sumRiskLevel',
      header: 'Som. Niveau Risque',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),
    
    
  ];
}
